<!--
 * @Description: 
 * @Version: 1.0
 * @Date: 2019-12-10 20:33:34
 * @Autor: LIANGYU
 * @LastEditTime : 2020-02-10 14:17:28
 * @LastEditors  : Please set LastEditors
 -->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {  }
  },
  methods: {
    
  },
  mounted() {
    
  },
}
</script>

<style>
#app{
  background: #f8f8f8;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue